//
//
//

import { UserLog } from '@/utils/log'
export default {
    data () {
        return {
            src: ''
        }
    },
    mounted () {
        const { building_id, title } = this.$route.query
        this.src = `https://wx.cdgoufang.com/sunlight?id=${building_id}&building_name=${title}`
        UserLog.viewBuildingSunlight(building_id, title)
        window.location.replace(this.src)
    }
}
